<template>
  <div class="history-view">
    <Tabs>
      <template #tab-selector>
        <button
          :class="{active: tabContent === TAB_HISTORY }"
          class="tab-link"
          @click="setTab(TAB_HISTORY)"
        >
          {{ $t('components.history.tabs.history') }}
        </button>
        <button
          :class="{active: tabContent === TAB_SUMMARY }"
          :disabled="!route.length"
          class="tab-link"
          @click="setTab(TAB_SUMMARY)"
        >
          {{ $t('components.history.tabs.summary') }}
        </button>
        {{ '' /* wyłączone podsumowanie daily */ }}
        <button
          v-if="false"
          :class="{active: tabContent === TAB_DAILY_SUMMARY }"
          :disabled="!route.length"
          class="tab-link"
          @click="setTab(TAB_DAILY_SUMMARY)"
        >
          {{ $t('components.history.tabs.dailySummary') }}
        </button>
        <button
          :class="{active: tabContent === TAB_ROUTE_REPORT }"
          :disabled="!allPropsPassed"
          class="tab-link"
          @click="setTab(TAB_ROUTE_REPORT)"
        >
          {{ $t('components.history.tabs.routeReport') }}
        </button>
      </template>
      <template #tab-content>
        <div v-show="tabContent === TAB_HISTORY">
          <div class="search-form row g-2 align-items-start">
            <div class="col-12 col-md-6 col-xl">
              <date-picker
                v-model="startDate"
                :class="{ 'custom-error': v.startDate.$error, 'is-invalid': v.startDate.$error }"
                :placeholder="$t('components.datepicker.startPlaceholder')"
                :type="'datetime'"
                :range="false"
                @emitDate="emitStartDate"
                :start-time="{ hours: 0, minutes: 0 }"
                :time-picker-inline="true"
              />
            </div>
            <div class="col-12 col-md-6 col-xl">
              <date-picker
                v-model="endDate"
                :class="{ 'custom-error': v.endDate.$error, 'is-invalid': v.endDate.$error }"
                :placeholder="$t('components.datepicker.endPlaceholder')"
                :type="'datetime'"
                :range="false"
                @emitDate="emitEndDate"
                :start-time="{ hours: 0, minutes: 0 }"
                :time-picker-inline="true"
              />
            </div>
            <div class="col-12 col-md-6 col-xl">
              <vue-select
                v-model="v.imei.$model"
                :class="{ 'custom-error': v.imei.$error, 'is-invalid': v.imei.$error }"
                :options="vehicles"
                icon="bi bi-truck"
                label="label"
                @updateSelect="emitVehicle"
              />
            </div>
            <div class="col-12 col-md-6 col-xl-auto">
              <button
                v-if="clickState !== constants.RUNNING"
                class="btn btn-success btn-search w-100"
                @click="searchRoutes"
              >
                {{ $t('components.search') }}
              </button>
              <button
                v-else
                class="btn btn-success btn-search btn-search-disabled w-100"
                :title="$t('components.history.tooltip')"
                data-bs-toggle="tooltip"
                disabled
              >
                {{ $t('components.search') }}
              </button>
            </div>
          </div>
          <QuickRangeButtons @rangeSelected="applyQuickRange" />
          <div class="errors">
            <p
              v-if="v.startDate.$error || v.endDate.$error || v.imei.$error"
              class="error-msg"
            >
              {{ $t('customValidators.allMustBeCompleted') }}
            </p>
          </div>
          <div
            v-if="showControls"
            id="steps"
            class="controls"
          >
            <vue-slider
              v-model="showRouteParameter"
              :clickable="false"
              :lazy="true"
              :max="route.length - 1"
              tooltip="none"
              @dragging="(value) => this.propRouteParameter = value"
            />
            <div id="controls">
              <div class="controls-btn-container">
                <button
                  class="btn btn-control"
                  @click="clickState === constants.SHOW_FULL_ROUTE ? setClickState(constants.HIDE_FULL_ROUTE) : setClickState(constants.SHOW_FULL_ROUTE)"
                >
                  <i class="bi bi-pin-map-fill" />
                </button>
                <button
                  class="btn btn-control"
                  @click="locked = !locked"
                >
                  <i
                    v-if="locked"
                    class="bi bi-lock-fill"
                  />
                  <i
                    v-else
                    class="bi bi-lock"
                  />
                </button>
                <button
                  v-if="clickState !== constants.RUNNING"
                  class="btn btn-control"
                  @click="setClickState(constants.RUNNING)"
                >
                  <i class="bi bi-play-fill" />
                </button>
                <button
                  v-if="clickState === constants.RUNNING"
                  class="btn btn-control"
                  @click="setClickState(constants.PAUSED)"
                >
                  <i class="bi bi-pause-fill" />
                </button>
                <button
                  class="btn btn-control"
                  @click="setClickState(constants.STOPPED)"
                >
                  <i class="bi bi-stop-fill" />
                </button>
                <button
                  class="btn btn-control"
                  @click="setAnimationDelay(1)"
                >
                  <i class="bi bi-chevron-double-left" />
                </button>
                <button
                  class="btn btn-control"
                  @click="setAnimationDelay(-1)"
                >
                  <i class="bi bi-chevron-double-right" />
                </button>
                <button
                  class="btn btn-control toogle-controls-btn"
                  @click="toggleInfo"
                >
                  <i
                    v-if="isInfoMinimized"
                    class="bi bi-chevron-down"
                  />
                  <i
                    v-else
                    class="bi bi-chevron-up"
                  />
                </button>
              </div>
              <div class="info-distance-container">
                <div class="info-item info-distance">
                  <i class="bi bi-signpost-2-fill" />
                  <span>{{ $t('components.history.totalMapDistance') }}: {{ formattedTotalMapDistance }} km</span>
                </div>
                <div class="info-item info-distance">
                  <i class="bi bi-signpost-2-fill" />
                  <span>{{ $t('components.history.totalCanDistance') }}: {{ formattedTotalCanDistance }} km</span>
                </div>
              </div>
              <div
                v-if="showControls"
                :style="{ display: isInfoMinimized ? 'none' : '' }"
                id="info"
              >
                <div
                  v-show="!isInfoMinimized"
                  class="info-item"
                >
                  <i class="bi bi-clock-fill" />
                  <span>{{ getHumanDateTime(additionalRouteParameters[showRouteParameter].device_timestamp) }}</span>
                </div>
                <div
                  v-show="!isInfoMinimized"
                  class="info-item"
                >
                  <i class="bi bi-chevron-double-right" />
                  <span>{{
                    animationDelayValues[animationDelayValues.findIndex(index => index.value === animationDelay)].key
                  }}x</span>
                </div>
                <div
                  v-show="!isInfoMinimized"
                  class="info-item info-heading"
                >
                  <i class="bi bi-signpost-split-fill" />
                  <span>{{ additionalRouteParameters[showRouteParameter].heading }}°</span>
                </div>
                <div
                  v-show="!isInfoMinimized"
                  class="info-item info-ignition"
                >
                  <i class="bi bi-key-fill" />
                  <span>{{
                    additionalRouteParameters[showRouteParameter].ignition ? $t('components.history.on') : $t('components.history.off')
                  }}</span>
                </div>
                <div
                  v-show="!isInfoMinimized"
                  class="info-item info-speed"
                >
                  <i class="bi bi-speedometer" />
                  <span>{{ additionalRouteParameters[showRouteParameter].basic_speed }} km/h</span>
                </div>
              </div>
              <div class="info-geo-coordinates-container">
                <div
                  v-show="!isInfoMinimized"
                  class="info-item info-geo-coordinates"
                >
                  <i class="bi bi-compass-fill" />
                  <span v-if="clickState !== constants.RUNNING && additionalRouteParameters[showRouteParameter].address">
                    {{ additionalRouteParameters[showRouteParameter].address }}
                  </span>
                  <span v-else>
                    {{ additionalRouteParameters[showRouteParameter].lat + ', ' + additionalRouteParameters[showRouteParameter].lng }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="map-section">
            <div
              v-if="mapLoading"
              class="map-loading-container"
            >
              <ScaleLoader />
              <p class="loading-text">
                {{ $t('components.history.loadingMap') }}
              </p>
            </div>
            <Map
              v-if="!mapLoading"
              :key="reloaded"
              ref="map"
              :additional-route-parameters="additionalRouteParameters"
              :animation-delay="animationDelay"
              :click-state="clickState"
              :locked="locked"
              :matched-route="matchedRoute"
              :prop-animation-pos="propRouteParameter"
              :route="route"
              :show-icons="false"
              :disable-last-vehicles-pos="true"
              @emitAnimationPos="(val) => this.showRouteParameter = val"
              @showControls="setControlsState"
              @updateClickState="(val) => setClickState(val)"
              @updateLocked="(val) => this.locked = val"
            />
            <div
              v-if="showControls && !mapLoading"
              id="functions"
            >
              <button
                class="btn btn-success btn-control"
                @click="exportCsv(additionalRouteParameters, 'route_' + getHumanDate(Date.now() / 1000))"
              >
                <i class="bi bi-filetype-csv" />
              </button>
              <button
                class="btn btn-success btn-control"
                style="padding: 5px 13px 5px 7px;"
                @click="clickState === constants.SHOW_ROUTE_POINTS ? setClickState(constants.HIDE_ROUTE_POINTS) : setClickState(constants.SHOW_ROUTE_POINTS)"
              >
                <i class="bi bi-hand-index" />
              </button>
              <button
                class="btn btn-success btn-control"
                @click="downloadMapPng"
                :title="$t('components.history.downloadMap')"
              >
                <i class="bi bi-image" />
              </button>
              <button
                class="btn btn-success btn-control"
                @click="generateReport"
                :title="$t('components.history.generateReport')"
              >
                <i class="bi bi-file-earmark-pdf" />
              </button>
            </div>
          </div>
        </div>
        <div
          v-show="tabContent === TAB_SUMMARY"
          v-if="allPropsPassed"
        >
          <Summary
            :key="reloaded"
            :date-from="startDate"
            :date-to="endDate"
            :imei="imei"
            :vehicle="vehicle"
            @summary-data-loaded="onSummaryDataLoaded"
          />
        </div>
        {{ '' /* wyłączone podsumowanie daily */ }}
        <div
          v-show="tabContent === TAB_DAILY_SUMMARY"
          v-if="false"
        >
          <DailySummary
            :key="reloaded"
            :date-from="startDate"
            :date-to="endDate"
            :imei="imei"
            :vehicle="vehicle"
          />
        </div>
        <div
          v-show="tabContent === TAB_ROUTE_REPORT"
        >
          <RouteReport
            v-if="allPropsPassed"
            :key="reloaded"
            :date-from="startDate"
            :date-to="endDate"
            :imei="imei"
            :vehicle="vehicle"
          />
          <div
            v-else
            class="no-data-message"
          >
            <div class="alert alert-info">
              <i class="bi bi-info-circle" />
              {{ $t('components.history.routeReport.noDataMessage') }}
            </div>
          </div>
        </div>
      </template>
    </Tabs>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {useI18n} from 'vue-i18n';
import DatePicker from '@/components/extras/DatePicker.vue';
import VueSelect from '@/components/extras/VueSelect.vue';
import {getMyVehicles, getReverseGeocode, getVehicleRoute} from '@/crud/getters';
import Tabs from '@/components/extras/Tabs.vue';
import Map from '@/components/content/Map.vue';
import {required} from '@/vuelidate/i18n-validators';
import useVuelidate from '@vuelidate/core';
import {datePrettier, generateCsv, getHumanDate, getHumanDateTime} from '@/utils/tools';
import VueSlider from 'vue-slider-component';
import constants from '@/utils/constants';
import dayjs from 'dayjs';
import {Tooltip} from 'bootstrap';
import Summary from '@/components/content/_partials/history/Summary.vue';
import DailySummary from '@/components/content/_partials/history/DailySummary.vue';
import RouteReport from '@/components/content/_partials/history/RouteReport.vue';
import QuickRangeButtons from '@/components/extras/QuickRangeButtons.vue';
import html2canvas from 'html2canvas';
import {jsPDF} from 'jspdf';
import autoTable from 'jspdf-autotable';
import {importFont} from '@/utils/jspdf/importFont';
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue';

const TAB_HISTORY = 0;
const TAB_SUMMARY = 1;
const TAB_DAILY_SUMMARY = 2;
const TAB_ROUTE_REPORT = 3;

export default defineComponent({
  name: 'History',
  components: { DailySummary, DatePicker, VueSelect, Tabs, Map, VueSlider, Summary, RouteReport, ScaleLoader, QuickRangeButtons },
  setup() {
    const { t } = useI18n();
    return { t, v: useVuelidate() };
  },
  data(): {
    TAB_HISTORY: number,
    TAB_SUMMARY: number,
    TAB_DAILY_SUMMARY: number,
    TAB_ROUTE_REPORT: number,
    vehicles: any,
    tabContent: any,
    startDate: string,
    endDate: string,
    imei: any,
    route: Array<any>,
    additionalRouteParameters: Array<any>,
    showRouteParameter: number,
    reloaded: number,
    showControls: boolean,
    showInfo: boolean,
    mapLoading: boolean,
    clickState: number,
    animationDelay: number,
    animationDelayValues: Array<any>,
    propRouteParameter: number,
    locked: boolean,
    constants: any,
    vehicle: any,
    allPropsPassed: boolean,
    isInfoMinimized: boolean,
    totalMapDistance: null,
    totalCanDistance: null,
    summaryData: any,
    mapHeightObserver: MutationObserver | null,
    matchedRoute: Array<[number, number]> | null,
  } {
    return {
      TAB_HISTORY: TAB_HISTORY,
      TAB_SUMMARY: TAB_SUMMARY,
      TAB_DAILY_SUMMARY: TAB_DAILY_SUMMARY,
      TAB_ROUTE_REPORT: TAB_ROUTE_REPORT,
      vehicles: [],
      tabContent: 0,
      startDate: '',
      endDate: new Date().toISOString().slice(0, 16),
      imei: null,
      route: [],
      additionalRouteParameters: [],
      showRouteParameter: 0,
      reloaded: 0,
      showControls: false,
      showInfo: false,
      mapLoading: false,
      clickState: constants.NOT_RUNNING_YET,
      animationDelay: 1000, // 1s
      animationDelayValues: [ // key, value - e.g. 1.5x is 800ms interval
        { key: 7, value: 50 },
        { key: 5, value: 100 },
        { key: 3, value: 300 },
        { key: 2, value: 500 },
        { key: 1.5, value: 800 },
        { key: 1, value: 1000 },
        { key: 0.8, value: 1500 },
        { key: 0.6, value: 2000 },
        { key: 0.4, value: 3000 },
        { key: 0.2, value: 5000 },
        { key: 0.1, value: 7000 }
      ],
      propRouteParameter: 0,
      locked: true,
      constants: constants,
      vehicle: null,
      totalMapDistance: null,
      totalCanDistance: null,
      summaryData: null,
      mapHeightObserver: null,
      matchedRoute: null,
      allPropsPassed: false,
      isInfoMinimized: true,
    }
  },
  methods: {
    async downloadMapPng(): Promise<void> {
      const mapRoot = (this.$refs.map as any)?.$el as HTMLElement | undefined;
      if (!mapRoot) return;

      const fnBar = document.getElementById('functions');
      const prevDisplay = fnBar?.style.display;
      if (fnBar) fnBar.style.display = 'none';

      try {
        // The MapLibre map is created with preserveDrawingBuffer enabled, so html2canvas
        // can rasterize the WebGL tiles together with the DOM markers/labels.
        const canvas = await html2canvas(mapRoot, {
          useCORS: true,
          allowTaint: false,
          backgroundColor: '#ffffff',
          scale: 1,
          logging: false
        });

        const a = document.createElement('a');
        a.download = `route_${this.getHumanDate(Date.now() / 1000)}.png`;
        a.href = canvas.toDataURL('image/png');
        a.click();
      } finally {
        if (fnBar) fnBar.style.display = prevDisplay ?? '';
      }
    },
    async generateReport(): Promise<void> {
      if (!this.route.length || !this.vehicle || !this.additionalRouteParameters.length) {
        (this as any).$swal.fire({
          icon: 'warning',
          title: 'Oops...',
          text: 'Brak danych do wygenerowania raportu. Najpierw wyszukaj trasę.'
        });
        return;
      }

      try {
        // Create PDF document
        const doc = new jsPDF();

        try {
          importFont(doc);
          doc.setFont('Roboto');
        } catch (fontError) {
          console.warn('Font import failed, using default font:', fontError);
          doc.setFont('times');
        }

        // Get vehicle registration number
        const vehicleRegistration = this.vehicle.registration || 'N/A';

        // Get start and end addresses
        const startPoint = this.additionalRouteParameters[0];
        const endPoint = this.additionalRouteParameters[this.additionalRouteParameters.length - 1];

        // Get addresses for start and end points
        let startAddress = 'N/A';
        let endAddress = 'N/A';

        if (startPoint.address) {
          startAddress = startPoint.address;
        } else {
          startAddress = `${startPoint.lat}, ${startPoint.lng}`;
        }

        // Get end address using reverse geocoding
        if (endPoint.address) {
          endAddress = endPoint.address;
        } else {
          try {
            const latLng = `${endPoint.lat},${endPoint.lng}`;
            const response = await getReverseGeocode(latLng);
            endAddress = response.data;
          } catch (error) {
            console.error('Error in reverse geocoding for end point:', error);
            endAddress = `${endPoint.lat}, ${endPoint.lng}`;
          }
        }

        const startOdometer = this.summaryData?.odometer_start || 0;
        const endOdometer = this.summaryData?.odometer_stop || 0;
        const startFuel = this.summaryData?.fuel_start || 0;
        const endFuel = this.summaryData?.fuel_stop || 0;
        const fuelConsumed = this.summaryData?.fuel_used || 0;
        const mapDistance = this.summaryData?.map_distance || 0;
        const canDistance = this.summaryData?.can_distance || 0;
        const fuelConsumptionMap = this.summaryData?.fuel_rate_map?.toFixed(2) || '0.00';
        const fuelConsumptionCan = this.summaryData?.fuel_rate_can?.toFixed(2) || '0.00';

        // Header with vehicle registration - single centered title
        doc.setFontSize(16);
        try {
          doc.setFont('Roboto', 'normal');
        } catch (e) {
          doc.setFont('times', 'normal');
        }

        // Single centered registration number
        const pageWidth = doc.internal.pageSize.width;
        doc.text(vehicleRegistration, pageWidth / 2, 20, { align: 'center' });

        // Date range
        doc.setFontSize(12);
        try {
          doc.setFont('Roboto', 'normal');
        } catch (e) {
          doc.setFont('times', 'normal');
        }
        const dateRange = `${this.$t('components.history.report.from')} ${this.startDate} ${this.$t('components.history.report.to')} ${this.endDate}`;
        doc.text(dateRange, pageWidth / 2, 35, { align: 'center' });

        // Capture map image
        const mapRoot = (this.$refs.map as any)?.$el as HTMLElement | undefined;
        if (mapRoot) {
          const fnBar = document.getElementById('functions');
          const prevDisplay = fnBar?.style.display;
          if (fnBar) fnBar.style.display = 'none';

          try {
            // MapLibre runs with preserveDrawingBuffer, so html2canvas captures the
            // WebGL tiles together with the DOM markers/labels.
            const canvas = await html2canvas(mapRoot, {
              useCORS: true,
              allowTaint: false,
              backgroundColor: '#ffffff',
              scale: 0.5,
              logging: false
            });

            // Add map image to PDF
            const imgData = canvas.toDataURL('image/png');
            const imgWidth = 180;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            doc.addImage(imgData, 'PNG', 15, 45, imgWidth, Math.min(imgHeight, 100));

            // Generate and add fuel report chart
            let currentY = 45 + Math.min(imgHeight, 100) + 10; // Position after map

            try {
              const fuelChartImage = await this.generateFuelChart();
              if (fuelChartImage) {
                const fuelImgWidth = 180;
                const fuelImgHeight = 100; // Fixed height for fuel chart
                doc.addImage(fuelChartImage, 'PNG', 15, currentY, fuelImgWidth, fuelImgHeight);
                currentY += fuelImgHeight + 10; // Update position for table
              }
            } catch (error) {
              console.warn('Failed to generate fuel chart:', error);
            }

            // Data table with translations
            const tableData = [
              [this.$t('components.history.report.vehicle'), `${vehicleRegistration}`],
              [this.$t('components.history.report.range'), `${this.$t('components.history.report.from')} ${this.startDate} ${this.$t('components.history.report.to')} ${this.endDate}`],
              [this.$t('components.history.report.mapDistance'), `${mapDistance} km`],
              [this.$t('components.history.report.canDistance'), `${canDistance} km`],
              [this.$t('components.history.report.odometerStart'), `${startOdometer} km`],
              [this.$t('components.history.report.odometerEnd'), `${endOdometer} km`],
              [this.$t('components.history.report.fuelStart'), `${startFuel} L`],
              [this.$t('components.history.report.fuelEnd'), `${endFuel} L`],
              [this.$t('components.history.report.fuelConsumed'), `${fuelConsumed} L`],
              [this.$t('components.history.report.fuelConsumptionMap'), `${fuelConsumptionMap} L`],
              [this.$t('components.history.report.fuelConsumptionCan'), `${fuelConsumptionCan} L`],
              [this.$t('components.history.report.startLocation'), startAddress],
              [this.$t('components.history.report.endLocation'), endAddress]
            ];

            // Add table below map and fuel chart
            autoTable(doc, {
              startY: currentY,
              head: [],
              body: tableData,
              theme: 'plain',
              styles: {
                fontSize: 9,
                cellPadding: 4,
                overflow: 'linebreak',
                halign: 'left',
                valign: 'top',
                lineColor: [0, 0, 0],
                lineWidth: 0.5
              },
              columnStyles: {
                0: {
                  fontStyle: 'bold',
                  cellWidth: 65
                },
                1: {
                  cellWidth: 115
                }
              },
              margin: { left: 15, right: 15 },
              tableWidth: 'auto',
              didDrawCell: function (data) {
                const { x, y, width, height } = data.cell;
                doc.setDrawColor(0, 0, 0);
                doc.setLineWidth(0.5);
                doc.rect(x, y, width, height);
              },
              willDrawCell: function (data) {
                if (data.row.index >= 11) {
                  data.cell.styles.minCellHeight = 24;
                  data.cell.styles.cellPadding = 5;
                }
              },
              didParseCell: function (data) {
                if (data.row.index >= 11) {
                  // wymuś font z polskimi znakami
                  data.cell.styles.font = 'Roboto';
                  data.cell.styles.fontStyle = (data.column.index === 0 ? 'bold' : 'normal');
                  data.cell.styles.fontSize = 10;
                  data.cell.styles.overflow = 'linebreak';

                  if (data.column.index === 1) {
                    const rawText = Array.isArray(data.cell.text)
                        ? data.cell.text.join(' ')
                        : String(data.cell.text ?? '');

                    const sanitized = rawText
                        .replace(/[\u200B-\u200D\uFEFF\u00AD]/g, '')
                        .replace(/\u00A0/g, ' ')
                        .replace(/\s+/g, ' ')
                        .trim()
                        .normalize('NFC');

                    const cp: any = data.cell.styles.cellPadding;
                    let padH = 5;
                    if (typeof cp === 'number') {
                      padH = cp;
                    } else if (Array.isArray(cp)) {
                      padH = (cp[1] ?? cp[0] ?? 5);
                    } else if (cp && typeof cp === 'object') {
                      padH = (cp.horizontal ?? cp.left ?? cp.right ?? 5);
                    }

                    const colWidth = 115 - 2 * padH;
                    data.cell.text = doc.splitTextToSize(sanitized, colWidth);
                  }
                }
              },
            });

            // Save the PDF
            doc.save(`raport_${vehicleRegistration}_${this.getHumanDate(Date.now() / 1000)}.pdf`);

          } finally {
            if (fnBar) fnBar.style.display = prevDisplay ?? '';
          }
        }

      } catch (error) {
        console.error('Error generating report:', error);
        (this as any).$swal.fire({
          icon: 'error',
          title: 'Błąd',
          text: 'Wystąpił błąd podczas generowania raportu.'
        });
      }
    },
    async generateFuelChart(): Promise<string | null> {
      try {
        const { getFuelReport } = await import('@/crud/getters');
        
        const fuelData = await getFuelReport(this.imei, this.startDate, this.endDate);
        
        if (!fuelData.data || !fuelData.data.length) {
          console.warn('No fuel data available');
          return null;
        }

        const canvas = document.createElement('canvas');
        canvas.width = 800;
        canvas.height = 400;
        canvas.style.backgroundColor = '#ffffff';
        
        canvas.style.position = 'absolute';
        canvas.style.top = '-9999px';
        canvas.style.left = '-9999px';
        document.body.appendChild(canvas);

        const { Chart, registerables } = await import('chart.js');
        Chart.register(...registerables);
        
        try {
          await import('chartjs-adapter-moment');
        } catch (e) {
          console.warn('chartjs-adapter-moment not available');
        }

        const fuelLevelValues: Array<{x: Date, y: number}> = [];
        const speedValues: Array<{x: Date, y: number}> = [];
        
        const { getDateTimeForChartJs } = await import('@/utils/tools');
        
        fuelData.data.forEach((item: any) => {
          const dateTimeString = getDateTimeForChartJs(item.device_timestamp);
          const localDate = new Date(dateTimeString);
          
          fuelLevelValues.push({ x: localDate, y: item.fuel_level || 0 });
          speedValues.push({ x: localDate, y: item.basic_speed || 0 });
        });

        const chartData = {
          datasets: [
            {
              label: this.$t('components.reports.fuel.fuelLevel'),
              data: fuelLevelValues,
              borderColor: 'rgba(246, 127, 1, 0.85)',
              backgroundColor: 'rgba(246, 127, 1, 0.85)',
              borderWidth: 2,
              tension: 0,
              pointRadius: 0, // Usuń kropki
              pointHoverRadius: 4, // Pokaż kropki tylko przy hover
              yAxisID: 'fuelLevel'
            },
            {
              label: this.$t('components.reports.fuel.speed'),
              data: speedValues,
              borderColor: 'rgba(51, 51, 51, 0.85)',
              backgroundColor: 'rgba(51, 51, 51, 0.85)',
              borderWidth: 2,
              tension: 0,
              pointRadius: 0,
              pointHoverRadius: 4,
              yAxisID: 'speed'
            }
          ]
        };

        const chart = new Chart(canvas, {
          type: 'line',
          data: chartData,
          options: {
            responsive: false,
            animation: false,
            plugins: {
              title: {
                display: true,
                text: this.$t('components.reports.fuel.fuelReport')
              }
            },
            scales: {
              x: {
                type: 'time',
                time: {
                  tooltipFormat: 'DD/MM/YYYY HH:mm',
                  displayFormats: {
                    'minute': 'HH:mm',
                    'hour': 'DD/MM HH:mm',
                    'day': 'DD/MM'
                  }
                }
              },
              fuelLevel: {
                type: 'linear',
                position: 'left',
                suggestedMin: 0,
                title: {
                  display: true,
                  text: this.$t('components.reports.fuel.fuelLevel'),
                  color: 'rgba(246, 127, 1, 0.85)'
                },
                ticks: {
                  color: 'rgba(246, 127, 1, 0.85)',
                  callback: function (value: any) {
                    return value + ' L';
                  }
                }
              },
              speed: {
                type: 'linear',
                position: 'right',
                suggestedMin: 0,
                title: {
                  display: true,
                  text: this.$t('components.reports.fuel.speed'),
                  color: 'rgba(51, 51, 51, 0.85)'
                },
                ticks: {
                  color: 'rgba(51, 51, 51, 0.85)',
                  callback: function (value: any) {
                    return value + ' km/h';
                  }
                },
                grid: {
                  drawOnChartArea: false
                }
              }
            }
          }
        });

        await new Promise(resolve => setTimeout(resolve, 1000));

        const chartImage = canvas.toDataURL('image/png');

        // Cleanup
        chart.destroy();
        document.body.removeChild(canvas);

        return chartImage;
      } catch (error) {
        console.error('Error generating fuel chart:', error);
        return null;
      }
    },
    onSummaryDataLoaded(data: any): void {
      this.summaryData = data;
    },
    fetchAddressForCurrentPoint() {
      const currentParam = this.additionalRouteParameters[this.showRouteParameter];
      if (currentParam && !currentParam.address) {
        const latLng = `${currentParam.lat},${currentParam.lng}`;
        getReverseGeocode(latLng)
            .then(response => {
              const updatedParam = {
                ...currentParam,
                address: response.data
              };
              this.additionalRouteParameters.splice(this.showRouteParameter, 1, updatedParam);
            })
            .catch(error => {
              console.error('Error in reverse geocoding:', error);
            });
      }
    },
    toggleInfo() {
      this.isInfoMinimized = !this.isInfoMinimized;
      this.adjustMapHeight();
    },
    adjustMapHeight() {
      if (window.innerWidth <= 768) {
        return;
      }

      if (this.$router.currentRoute.value.path === '/history') {
        const mapElement = document.getElementById('map');
        const controlsElement = document.getElementById('controls');
        if (mapElement) {
          const desiredHeight = this.isInfoMinimized ? '73vh' : (controlsElement ? '68vh' : '80vh');

          // Re-fit only on an actual height change - this method is fired by a
          // body-wide MutationObserver, so an unconditional fitBounds would keep
          // resetting the user's zoom (e.g. during route playback).
          if (mapElement.style.height !== desiredHeight) {
            mapElement.style.height = desiredHeight;
            this.refreshMapBounds();
          }
        }
      }
    },
    refreshMapBounds() {
      if (this.route.length > 0) {
        this.$nextTick(() => {
          const mapComponent = this.$refs.map as unknown as {
            fitBounds: (bounds: any) => void,
            invalidateSize?: () => void
          };

          if (mapComponent) {
            if (typeof mapComponent.invalidateSize === 'function') {
              mapComponent.invalidateSize();
            }

            setTimeout(() => {
              if (typeof mapComponent.fitBounds === 'function') {
                mapComponent.fitBounds(this.route);
              }
            }, 100);
          }
        });
      }
    },
    datePrettier: datePrettier,
    emitStartDate(value): void {
      if (Array.isArray(value)) {
        this.startDate = dayjs(value[0]).format('YYYY-MM-DD HH:mm');
      } else {
        this.startDate = dayjs(value).format('YYYY-MM-DD HH:mm');
      }
    },
    emitEndDate(value): void {
      if (Array.isArray(value)) {
        this.endDate = dayjs(value[0]).format('YYYY-MM-DD HH:mm');
      } else {
        this.endDate = dayjs(value).format('YYYY-MM-DD HH:mm');
      }
    },
    applyQuickRange(range: { start: string, end: string }): void {
      this.startDate = range.start;
      this.endDate = range.end;
    },
    emitVehicle(value): void {
      if (value) {
        this.vehicle = value
        this.imei = BigInt(value.device.imei)
      } else {
        this.vehicle = null
        this.imei = null
      }
    },
    async searchRoutes(): Promise<void> {
      const result = await this.v.$validate();
      const self: any = this;
      if (result) {
        const formattedStartDate = this.startDate || '';
        const formattedEndDate = this.endDate || dayjs().format('YYYY-MM-DD HH:mm');

        // Rozpocznij ładowanie mapy
        this.mapLoading = true;

        getVehicleRoute(this.imei, formattedStartDate, formattedEndDate)
            .then((res) => {
              const routeData = res.data.route_data;
              const totalMapDistance = res.data.total_map_distance;
              const totalCanDistance = res.data.total_can_distance;

              if (!routeData.length) {
                self.$swal.fire({
                  icon: 'warning',
                  title: 'Oops...',
                  text: this.$t('vueSelect.noResults')
                });
              } else {
                let processedRouteData = routeData;
                if (routeData.length > 10000) {
                  const step = Math.ceil(routeData.length / 5000);
                  processedRouteData = routeData.filter((_, index) => index % step === 0);
                }
                
                this.route = processedRouteData.map(obj => [parseFloat(obj.lat), parseFloat(obj.lng)]);
                this.matchedRoute = Array.isArray(res.data.matched_route) && res.data.matched_route.length > 1
                    ? res.data.matched_route
                    : null;
                this.additionalRouteParameters = routeData.map(obj => ({
                  ...obj,
                  address: ''
                }));
                // Przechowaj sumy przejechanych kilometrów
                this.totalMapDistance = totalMapDistance;
                this.totalCanDistance = totalCanDistance;

                // Dane summary będą pobrane automatycznie przez komponent Summary

                this.reloaded++;
                this.setClickState(constants.SHOW_FULL_ROUTE);
                this.allPropsPassed = true;
                
                setTimeout(() => {
                  if (this.mapLoading) {
                    this.mapLoading = false;
                    this.$nextTick(() => {
                      this.refreshMapBounds();
                    });
                  }
                }, 5000);
              }
            })
            .catch((err) => {
              // Zatrzymaj ładowanie w przypadku błędu
              this.mapLoading = false
              if (err.response && err.response.status === 400) {
                self.$swal.fire({
                  icon: 'warning',
                  title: 'Oops...',
                  text: this.$t('components.searchInterval')
                });
              } else {
                self.$swal.fire({
                  icon: 'error',
                  title: 'Błąd',
                  text: 'Wystąpił błąd podczas pobierania trasy. Spróbuj ponownie.'
                });
              }
            });
      }
    },
    setControlsState(value): void {
      this.showControls = value
      if (value && this.mapLoading) {
        const delay = this.route.length > 5000 ? 2000 : 500;
        setTimeout(() => {
          this.mapLoading = false
          this.$nextTick(() => {
            this.refreshMapBounds()
          })
        }, delay);
      }
    },
    setClickState(value): void {
      this.clickState = value
    },
    setAnimationDelay(multiplier: number): void {
      const index = this.animationDelayValues.findIndex(index => index.value === this.animationDelay)
      if (index !== 0 && multiplier === -1 || index !== 10 && multiplier === 1)
        this.animationDelay = this.animationDelayValues[index + multiplier].value
    },
    getVehicleName(obj): string {
      return obj.vars.name == null || obj.vars.name === '' ? obj.registration : `${ obj.vars.name } [${ obj.registration }]`
    },
    getHumanDateTime: getHumanDateTime,
    getHumanDate: getHumanDate,
    exportCsv(data, filename) {
      generateCsv(data, filename, this.t, this.$i18n.locale);
    },
    async setTab(tab: number) {
      await this.setClickState(constants.PAUSED)
      this.tabContent = tab
    }
  },
  mounted() {
    const self = this

    // Add history-page class to body for CSS targeting
    document.body.classList.add('history-page');

    getMyVehicles()
        .then((response: any) => {
          while (this.vehicles.length > 0) {
            this.vehicles.pop()
          }
          response.data.forEach(function (obj) {
            obj.label = self.getVehicleName(obj)
            self.vehicles.push(obj)
          })
        })

    /**
     * Initialize bootstrap tooltip
     */
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new Tooltip(tooltipTriggerEl)
    });

    this.mapHeightObserver = new MutationObserver(() => {
      this.adjustMapHeight();
    });
    this.mapHeightObserver.observe(document.body, { childList: true, subtree: true });

    // Initial check
    this.adjustMapHeight();
  },
  beforeUnmount() {
    if (this.mapHeightObserver) {
      this.mapHeightObserver.disconnect();
      this.mapHeightObserver = null;
    }
    document.body.classList.remove('history-page');
  },
  validations() {
    return {
      startDate: { required },
      endDate: { required },
      imei: { required }
    }
  },
  computed: {
    formattedTotalMapDistance() {
      return this.totalMapDistance !== null ? this.totalMapDistance : 'N/A';
    },
    formattedTotalCanDistance() {
      return this.totalCanDistance !== null ? this.totalCanDistance : 'N/A';
    },
  },
  watch: {
    clickState(newVal) {
      if (newVal !== constants.RUNNING) {
        this.fetchAddressForCurrentPoint();
      }
    },
    showRouteParameter() {
      if (this.clickState !== constants.RUNNING) {
        this.fetchAddressForCurrentPoint();
      }
    },
  },
})
</script>
<style lang="scss" scoped>
$background-with-opacity: rgba(51, 51, 51, 0.5);
$primary-color: #f67f01;
$hover-color: #e06900;
$text-color: #1e1e2d;

#map {
  margin-top: 30px;
}

.errors {
  position: absolute;

  p {
    margin: 5px 0 0 0;
  }
}

#controls {
  background: transparent;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid $primary-color;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  position: relative;

  .btn {
    background-color: $primary-color;
    border: none;
    border-radius: 5px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;

    i {
      font-size: 1.5rem;
      color: #fff;
    }

    &:hover {
      background-color: $hover-color;
    }
  }

  .controls-btn-container {
    display: flex;
    justify-content: space-evenly;
    width: 70%;
  }

  #info {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 15px;
    color: $text-color;
    font-size: 1.2rem;
    padding: 20px 20px 0;
    max-height: 500px; // maksymalna wysokość, gdy element jest widoczny
    overflow: hidden;
    transition: max-height 0.5s ease;

    &.minimized {
      max-height: 0;
    }

    i {
      font-size: 1.5rem;
      color: $primary-color;
    }

    div {
      display: flex;
      align-items: center;
      gap: 5px;

      span {
        font-size: 1.2rem;
        color: $text-color;
      }
    }

    p {
      margin: 0;
      font-size: 1.2rem;
    }

    .info-geo-coordinates {
      width: 200px;
    }

    .info-ignition {
      width: 100px;
    }

    .info-heading {
      width: 60px;
    }

    .info-speed {
      width: 100px;
    }
  }
}

.info-distance-container, .info-geo-coordinates-container {
  display: flex;
  align-items: center;
  gap: 100px;
  justify-content: center;
  width: 100%;
  margin: 0;


  .info-geo-coordinates {
    text-align: center;
    padding: 10px 20px;
  }

  i {
    font-size: 1.5rem;
    color: $primary-color;
  }

  span {
    font-size: 1.2rem;
    color: $text-color;
    padding-left: 5px;
  }

  .info-distance {
    padding: 10px 20px;
    align-items: center;
    display: flex;
  }
}
#steps {
  margin: 5px 0 -24px 0;
}

#functions {
  z-index: 1000;
  background: $background-with-opacity;
  padding: 10px;
  border-radius: 0 10px 0 0;
  position: absolute;
  bottom: 17px;

  .btn {
    margin: 0 2px;
    padding: 5px 10px;

    i {
      font-size: 1.7rem;
      padding: 0;
    }
  }
}
.tab-content > div {
  padding: 15px 15px 0;
  margin-bottom: 0;
}

#controls {
  .toogle-controls-btn {
    background: none;
    position: absolute;
    right: 15px;
    i {
      color: $primary-color !important;
      &:hover {
        color: $hover-color !important;
      }
    }
    &:hover {
      background: none;
    }
  }
}

.no-data-message {
  padding: 20px;
  text-align: center;
  
  .alert {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 15px 20px;
    border-radius: 8px;
    background-color: #d1ecf1;
    border: 1px solid #bee5eb;
    color: #0c5460;
    
    i {
      font-size: 1.2rem;
    }
  }
}

.map-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  margin-top: 30px;
  
  .loading-text {
    margin-top: 20px;
    font-size: 1.1rem;
    color: #6c757d;
    text-align: center;
  }
}

// Mobile responsive styles
@media (max-width: 768px) {
  // Container fixes
  .history-view {
    height: auto !important;
    min-height: auto !important;
    max-height: none !important;
    overflow-y: auto !important;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;

    .sidebars-container,
    .container,
    .post,
    .content {
      height: auto !important;
      min-height: auto !important;
    }

    .h-100px,
    .min-h-100px,
    .mh-100px {
      height: auto !important;
      min-height: auto !important;
      max-height: none !important;
    }
  }

  // Tabs
  .history-view .tab {
    position: relative;
    background: white;
    padding: 5px 0;
  }
  .history-view .tab-content {
    height: auto !important;
    min-height: 100vh !important;
    max-height: none !important;

    > div {
      position: relative;
      background: #f5f8fa;
      padding: 10px;
      height: auto !important;
      max-height: none !important;
      min-height: calc(100vh - 80px) !important;
      overflow: visible !important;
    }
  }

  // Search form
  .history-view .search-form {
    position: relative;
    background: #f5f8fa;
    padding: 10px;
    margin-bottom: 10px;

    .btn-search-disabled {
      opacity: 0.6;
      cursor: not-allowed;
      background-color: #6c757d !important;
      border-color: #6c757d !important;

      &:hover {
        background-color: #6c757d !important;
        border-color: #6c757d !important;
      }
    }
  }

  // Map section
  .history-view .map-section {
    position: relative;
    background: #f5f8fa;
    margin-top: 25px;
    border-radius: 8px;
    padding: 15px;
    max-height: 80vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .history-view #map {
    position: relative !important;
    margin-top: 0;
    height: 50vh !important;
    min-height: 300px !important;
    max-height: 60vh !important;
    width: 100% !important;
    border-radius: 6px;
    overflow: hidden;
    top: auto !important;
    left: auto !important;
    right: auto !important;
    bottom: auto !important;
  }

  // Controls
  .history-view #steps {
    position: relative;
    margin: 10px 0;
  }
  .history-view #controls {
    position: relative;
    background: transparent;
    margin-top: 10px;
    border-radius: 8px;

    .controls-btn-container {
      display: flex;
      justify-content: space-between;
      width: 100%;
      gap: 8px;
      margin-bottom: 15px;

      .btn {
        flex: 1;
        padding: 8px 4px;
        min-height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 1.1rem;
        }
      }

      .toogle-controls-btn {
        flex: 0 0 44px;
        position: relative;
        right: 0;
        top: 0;
      }
    }
  }

  // Info sections
  .history-view .info-distance-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    gap: 15px;

    .info-distance {
      flex: 1;
      padding: 10px;
      background: rgba(246, 127, 1, 0.1);
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      i {
        font-size: 1.2rem;
        margin-right: 8px;
        flex-shrink: 0;
      }

      span {
        font-size: 0.9rem;
        line-height: 1.2;
      }
    }
  }

  .history-view #info {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 8px;
    padding: 10px 0;

    .info-item {
      flex: 1;
      min-width: calc(50% - 4px);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px;
      background: rgba(246, 127, 1, 0.05);
      border-radius: 4px;
      text-align: center;

      i {
        font-size: 1rem;
        margin-right: 6px;
        flex-shrink: 0;
      }

      span {
        font-size: 0.85rem;
        line-height: 1.1;
      }
    }
  }

  .history-view .info-geo-coordinates-container {
    .info-geo-coordinates {
      width: 100%;
      padding: 10px;
      background: rgba(246, 127, 1, 0.05);
      border-radius: 6px;
      display: flex;
      align-items: flex-start;
      text-align: left;

      i {
        font-size: 1.1rem;
        margin-right: 8px;
        margin-top: 2px;
        flex-shrink: 0;
        color: #f67f01;
      }

      span {
        font-size: 0.85rem;
        line-height: 1.3;
        word-break: break-word;
      }
    }
  }

  // Functions
  .history-view #functions {
    position: relative;
    background: rgba(51, 51, 51, 0.5);
    border-radius: 8px;
    margin-top: 10px;
    padding: 10px;
    text-align: center;

    .btn {
      margin: 0 5px;
    }
  }
}
</style>